import React from 'react'
import { isReactNativeAndroid, subscribeToNative } from '@mobi/web-native-comms/web'
import { appHistory } from '@core/Utils/routing/history'

export const useAndroidBackButton = (): void => {
  React.useEffect(() => {
    if (!isReactNativeAndroid) return undefined

    const subscription = subscribeToNative('ANDROID_NAVIGATE_BACK', () => {
      appHistory.back()
    })
    return () => {
      subscription?.dispose()
    }
  }, [])
}
